gz-widget-section-item {
  --item-icon-width: unset;
  --item-name-font-size: var(--body-size-large);
  --item-name-font-family: var(--font-family-secondary);
  --item-name-color: var(--main-titles-inputs-600);

  &:last-of-type,
  &:first-of-type {
    --row-border-bottom: none;
  }

  &.total-incidents {
    --item-name-font-family: var(--font-family);
  }

  &:first-of-type {
    --item-name-font-weight: 600;
  }

  &:hover {
    --item-name-color: var(--blue-layout-400-primary);
  }
}

.loading-section:first-of-type {
  margin-top: 28px;
}

.pointer {
  cursor: pointer;
}
